// Extensiones FHIR nuevas de la Fase 5 (recetas y farmacia), namespace
// `http://logiacare.ec/fhir/` — mismo patrón que `nivel-cuidado-intensivo`
// (cuidadoIntensivo.tsx): constante de la url, filtra las extensiones
// previas de ese mismo url, agrega la nueva. Ambas viven en
// `MedicationRequest.extension`, nunca se editan tras la firma (bloqueo
// duro en auditedFetch.ts) — se fijan una sola vez, al crear el recurso.
import type { Extension, MedicationRequest } from '@medplum/fhirtypes';

/** `valueString` — homologación manual con el número de serie del formulario físico de ACESS (2.8, ruta 1; la ruta 2/API no se construye). */
export const EXT_NUMERO_SERIE_RECETA_ESPECIAL = 'http://logiacare.ec/fhir/numero-serie-receta-especial';

/** `valueBoolean` — bandera manual del médico (2.8). El catálogo solo la sugiere (Forma_venta = "Bajo receta controlada"), nunca la fija sola. */
export const EXT_SUSTANCIA_CONTROLADA = 'http://logiacare.ec/fhir/sustancia-controlada';

function conExtension(previas: Extension[] | undefined, url: string, valor: Omit<Extension, 'url'>): Extension[] {
  const otras = (previas ?? []).filter((e) => e.url !== url);
  return [...otras, { url, ...valor }];
}

export interface DatosRecetaExtension {
  sustanciaControlada: boolean;
  numeroSerieRecetaEspecial?: string;
}

/** Arma `MedicationRequest.extension` con las dos extensiones de Fase 5 — se llama una sola vez, al crear el recurso (construirReceta). */
export function extensionesReceta(datos: DatosRecetaExtension): Extension[] {
  let extension = conExtension(undefined, EXT_SUSTANCIA_CONTROLADA, { valueBoolean: datos.sustanciaControlada });
  if (datos.numeroSerieRecetaEspecial) {
    extension = conExtension(extension, EXT_NUMERO_SERIE_RECETA_ESPECIAL, { valueString: datos.numeroSerieRecetaEspecial });
  }
  return extension;
}

export function esSustanciaControlada(mr: Pick<MedicationRequest, 'extension'>): boolean {
  return mr.extension?.find((e) => e.url === EXT_SUSTANCIA_CONTROLADA)?.valueBoolean === true;
}

export function numeroSerieRecetaEspecialDe(mr: Pick<MedicationRequest, 'extension'>): string | undefined {
  return mr.extension?.find((e) => e.url === EXT_NUMERO_SERIE_RECETA_ESPECIAL)?.valueString;
}
